<template>
  <v-container fluid class="container grey lighten-2" style="height:100%;">
    <v-row justify="center" align="center" style="height:80%;">
      <v-col cols="5">
        <v-card tile style="opacity: 0.8;" min-height="400">
          <v-card-title>
            <div>
              <v-icon large color="green" class="mr-2">mdi-check-circle</v-icon>
              登录成功
            </div>
          </v-card-title>
          <v-card-text>
            <v-row align="center">
              <v-col cols="12" class="text-h5 teal--text pl-6">
                欢迎使用【中科新生命生信云平台】
              </v-col>
              <v-col cols="12">
                <v-row dense align="center">
                  <v-col cols="auto">
                    <v-icon color="teal" class="mdi-rotate-90" x-large>mdi-window-minimize</v-icon>
                  </v-col>
                  <v-col cols="auto" class="text-h5 teal--text">快速导航</v-col>
                </v-row>
              </v-col>
              <v-col cols="12">
                <v-row dense class="pl-12">
                  <router-link class="text-h6 primary--text" to="/" replace>首页</router-link>
                  <router-link class="text-h6 primary--text ml-4" to="/profile/summary" replace>个人中心</router-link>
                  <!-- <router-link class="text-h6 primary--text ml-4" to="/tutorial" replace>视频教程</router-link> -->
                  <router-link class="text-h6 primary--text ml-4" to="/tool" replace>分析工具</router-link>
                  <router-link class="text-h6 primary--text ml-4" to="/project" replace>我的项目</router-link>
                  <router-link class="text-h6 warning--text ml-4" to="/profile/auth" replace>修改密码</router-link>
                </v-row>
              </v-col>
              <v-col cols="12" class="pl-6 mt-12">
                <p class="text-h6 warning--text">请您及时修改您的登录密码</p>
                <span class="text-h6 red--text"> {{stopSec}} </span> 秒后自动跳转到修改密码页面
              </v-col>

            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  data () {
    return { stopSec: 10 }
  },
  mounted () {
    let currPath = this.$router.currentRoute.path;
    let timer = setInterval(() => {
      this.stopSec--;
      if (this.stopSec <= 0) {
        clearInterval(timer);
        timer = undefined;
        let newCurrPath = this.$router.currentRoute.path;
        if (currPath == newCurrPath) this.$router.push({ path: '/profile/auth', replace: true });
      }
    }, 1000);
  }
}
</script>